﻿export class BooleanResult {
    constructor(public value: boolean) {
    }
}